import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import { header } from 'constants/table';
import { RowItemThongKeGiamSatNhapDonCu } from './datatable';
import DataTable from 'components/data-table';
import { TheoDoiGiamSat } from 'api';
import { DropDownChonLoaiDonThu, DropDownChonNguonDon} from 'components/tt-forms';
import classnames from 'classnames';

class ThongKeGiamSatNhapDonCu extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      id: this.props.id,
      sum: {
        tongSoDon: 0,
        tongSoDonDonGian: 0,
        tongSoDonPhucTap: 0
      },
      pageData: {
        number: 0,
        size: 10,
        totalElements: 50
      },
      tableLoading: false,
      searchLoading: false,
      search: false,
      phanLoaiDon: '',
      nguonDon: ''
    }
  }

  componentDidMount() {
    this.getListData(this.props.id);
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.id !== nextProps.id) {
      this.getListData(nextProps.id);
    }
  }

  getListData(id) {
    let params = {
      nguonDon: this.state.nguonDon,
      phanLoaiDon: this.state.phanLoaiDon,
      donViId: id
    };
    this.setState({
      tableLoading: true,
      searchLoading: true
    });
    if (id) {
      return  TheoDoiGiamSat.actions.getThongKeSoLieuDonCuTheoDonViCon.request('',params).then(res => {
        if (res.data){
          this.setState({
            data: res.data.donVis,
            sum: {
              tongSoDon: res.data.tongSoDon
            },
            tableLoading: false,
            searchLoading: false,
            search: false
          });
        }
      })
    }
    return  TheoDoiGiamSat.actions.getThongKeSoLieuDonCuTheoDonVi.request('',params).then(res => {
      if (res.data) {
        this.setState({
          data: res.data.donVis,
          sum: {
            tongSoDon: res.data.tongSoDon,
            tongSoDonDonGian: res.data.tongSoDonDonGian,
            tongSoDonPhucTap: res.data.tongSoDonPhucTap
          },
          tableLoading: false,
          searchLoading: false,
          search: false
        });
      }
    })
  }

  handleChange(name, e) {
    this.setState({[name]: e.target.value});
  }

  handleSearch(e){
    e.preventDefault();
    this.setState({
      search: true
    }, () => {
      this.getListData(this.props.id);
    });
    return;
  }

  render() {
    return (
      <div className="center reception-container">
        {
          this.props.id &&
            <div className="back-foward mb0">
              <Link onClick={ browserHistory.goBack } title="">Về trang trước</Link>
            </div>
        }
        <div className="top-content">
          <div className="left-content">
            <p className="title-18"><i className="tt tt-theo-doi"></i>Thống kê giám sát nhập đơn cũ</p>
          </div>
        </div>
        <div className="bottom-content">
          <form className='wrap-block pl15 pr15 pt20' onSubmit={this.handleSearch.bind(this)}>
            <div className='row pl10 pr10'>
            <DropDownChonNguonDon selectedValue={this.state.nguonDon} onChange={this.handleChange.bind(this, 'nguonDon')} className="col-25" />
            <DropDownChonLoaiDonThu selectedValue={this.state.phanLoaiDon} onChange={this.handleChange.bind(this, 'phanLoaiDon')} className="col-25" />
              <div className='col'>
                <div className="rows">
                  <div className='col-16 mb0-18 search-thanh-tra clear-right'>
                    {/* <button className={this.state.searchLoading ? (this.state.search ? 'btn-loading-inline btn-disable btn-green' : 'btn-disable btn-green') : 'btn-green'} type='submit' disabled={ this.state.searchLoading ? 'disabled' : '' }><i className='tt-search'></i>Xem kết quả</button> */}
                    <button className={classnames('btn-green', {'btn-loading-inline': this.state.searchLoading, 'btn-disable': this.state.search})} type='submit' disabled={ this.state.searchLoading ? 'disabled' : '' }><i className='tt-search'></i>Xem kết quả</button>
                  </div>
                </div>
              </div>
            </div>
            <div className='row'>
              <span className="line-border"></span>
            </div>
          </form>
          <DataTable
            header={header.theoDoi.thongKeGiamSatNhapDonCu}
            dataList={this.state.data}
            hidePagination
            pageData={this.state.pageData}
            parent={this}
            search={this.state.search}
            tableLoading={this.state.tableLoading}
            thongKeDonCu={true}
            {... this.state.sum}
          >
            <RowItemThongKeGiamSatNhapDonCu phanLoaiDon={this.state.phanLoaiDon} nguonDon={this.state.nguonDon}/>
          </DataTable>
        </div>
      </div>
    )
  }
}

ThongKeGiamSatNhapDonCu.defaultProps = {
  validators: {
    formTaoDon: []
  }
}

export default ThongKeGiamSatNhapDonCu;


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-giam-sat/ThongKeGiamSatNhapDonCu.jsx